import { classNames } from "@opensea/ui-kit"
import { useIsHydrated } from "@opensea/ui-kit/hooks"
import { useSearchParams } from "next/navigation"

export function useRowHighlightClassNames(id?: string) {
  const isHydrated = useIsHydrated()
  const searchParams = useSearchParams()

  const highlightIds = (searchParams.get("highlight") || "").split(",")
  const highlight = id && highlightIds.includes(id)

  return classNames(
    "before:pointer-events-none before:absolute before:inset-0 before:size-full before:rounded-inherit",
    "before:transition-colors before:delay-200 before:duration-2500 before:ease-out-quint",
    highlight && !isHydrated && "before:bg-primary/15",
  )
}
